import { render, staticRenderFns } from "./create-your-account.vue?vue&type=template&id=4c140ca6&scoped=true&lang=pug&"
import script from "./create-your-account.vue?vue&type=script&lang=js&"
export * from "./create-your-account.vue?vue&type=script&lang=js&"
import style0 from "./create-your-account.vue?vue&type=style&index=0&id=4c140ca6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c140ca6",
  null
  
)

export default component.exports